export class FileUtils {

    /**
     * Converte una stringa base64 in un oggetto Blob
     * @param base64 
     * @param mimeType 
     * @returns 
     **/
    static base64ToBlob(base64: string, mimeType: string): Blob {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mimeType });
    }

    /**
     * Simula il download di un file a partire da un oggetto Blob
     * @param blob 
     * @param fileName 
     */
    static simulateFileDownloadFromBlob(blob: Blob, fileName: string) {
        const link: HTMLAnchorElement = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
    }
}